import { useStores } from '../../stores';
import { AggregationParameter } from '../../stores/QuaterlyReportStore';
import { getStartDateAndEndDate } from '../custom-hooks/PlanDates';

export interface Payload {
  eg_nid: string[];
  aggregationParameter: AggregationParameter;
  incurredStartDate?: string;
  incurredEndDate?: string;
  paidStartDate?: string;
  paidEndDate?: string;
  minPaid?: string;
  minIncurred?: string;
  maxIncurred?: string;
  maxPaid?: string;
}
export const useAPIPayload = () => {
  const quarterlyReportStore = useStores().quaterlyReportStore;
  const employerGroupStore = useStores().employerGroupStore;

  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    aggregationParameter,
    minIncurred,
    maxIncurred,
    minPaid,
    maxPaid,
    noDateFilter,
  } = quarterlyReportStore;

  const { eg_nid } = employerGroupStore.employerGroupResponseData;
  const { startDate, endDate } = getStartDateAndEndDate();

  let payload: Payload = {
    eg_nid,
    aggregationParameter,
  };
  if (noDateFilter) {
    payload = {
      ...payload,
      incurredStartDate: minIncurred,
      incurredEndDate: maxIncurred,
      paidStartDate: minPaid,
      paidEndDate: maxPaid,
      minPaid: minPaid,
      minIncurred: minIncurred,
      maxIncurred: maxIncurred,
      maxPaid: maxPaid,
    };
  } else if (isIncurredDate && isPaidDate) {
    payload = {
      ...payload,
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      minPaid: minPaid,
      minIncurred: minIncurred,
      maxIncurred: maxIncurred,
      maxPaid: maxPaid,
    };
  } else if (isIncurredDate) {
    payload = {
      ...payload,
      incurredStartDate,
      incurredEndDate,
      paidStartDate: '',
      paidEndDate: '',
      minPaid: minPaid,
      minIncurred: minIncurred,
      maxIncurred: maxIncurred,
      maxPaid: maxPaid,
    };
  } else if (isPaidDate) {
    payload = {
      ...payload,
      incurredStartDate: '',
      incurredEndDate: '',
      paidStartDate,
      paidEndDate,
      minPaid: minPaid,
      minIncurred: minIncurred,
      maxIncurred: maxIncurred,
      maxPaid: maxPaid,
    };
  } else {
    payload = {
      ...payload,
      incurredStartDate: startDate,
      incurredEndDate: endDate,
      paidStartDate: '',
      paidEndDate: '',
      aggregationParameter: 'incurred',
      minPaid: minPaid,
      minIncurred: minIncurred,
      maxIncurred: maxIncurred,
      maxPaid: maxPaid,
    };
  }

  return payload;
};
